import { createStore, combineReducers } from "redux";
import adminUserReducer from "./reducers/adminUser";
import currentUserReducer from "./reducers/currentUser";
import LoaderReducer from "./reducers/Loader";
import projectFiltersReducer from "./reducers/projectFilters";
import { composeWithDevTools } from "redux-devtools-extension";

const PROJECT_FILTERS_STORAGE_KEY = "projectFilters.appliedFilters";

const loadPreloadedState = () => {
  try {
    const storedAppliedFilters = window.localStorage.getItem(
      PROJECT_FILTERS_STORAGE_KEY,
    );
    if (!storedAppliedFilters) return undefined;

    const appliedFilters = JSON.parse(storedAppliedFilters);
    if (!Array.isArray(appliedFilters)) return undefined;

    return {
      projectFiltersReducer: {
        appliedFilters,
      },
    };
  } catch (error) {
    console.error("Failed to load project filters from localStorage", error);
    return undefined;
  }
};

const reducers = combineReducers({
  adminUserReducer,
  currentUserReducer,
  LoaderReducer,
  projectFiltersReducer,
});

const store = createStore(
  reducers,
  loadPreloadedState(),
  composeWithDevTools(),
);

export default store;
